<template>
  <div>
    <div class="screen1">
      <div class="screen1-container">
        <div class="screen1-nav">
          <div class="screen1-nav-logo">
            <img src="../assets/images/Logo.png" alt="">
          </div>
          <div class="screen1-nav-tabs" style="display:flex;align-items: center;">
            <div class="screen1-nav-menu">
              <span @click="handleToPage('protac')" style="color:#fff;font-weight:bold">{{ $t('from.index') }}</span>
              <span @click="handleToPage('services', 1)">{{ $t('from.service') }}</span>
              <span @click="handleToPage('productView', 5)">{{ $t('from.product') }}</span>
              <span @click="handleToPage('about', 2)">{{ $t('from.about') }}</span>
              <span @click="handleToPage('testimonial', 3)">{{ $t('from.putai') }}</span>
              <span @click="handleToPage('contact', 4)">{{ $t('from.contact') }}</span>
            </div>
            <el-dropdown class="nav-right" @command="handleCommand">
              <el-button class="nav-btn" round>{{ $t('from.changeLanguage') }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="英文"> {{ $t('language.English') }}</el-dropdown-item>
                <el-dropdown-item command="中文">{{ $t('language.Chinese') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <i class="el-icon-s-operation iconfont" @click="handleShowMenu" v-if="!isShow"></i>
            <i class="el-icon-close iconfont" @click="handleCloseMenu" v-if="isShow"></i>
          </div>
        </div>
        <h1 class="heading-h1">{{ $t('from.company') }}</h1>
        <h1 class="heading-h1">{{ $t('from.supplier') }}</h1>
        <h1 class="heading-h1">{{ $t('from.design') }}</h1>
        <el-button type="success" class="elementor-button-text" plain @click="handleGoTop">{{ $t('from.more')
        }}</el-button>
      </div>
    </div>
    <div class="show-builder-menu" v-if="isShow">
      <span @click="handleToPage('protac')">{{ $t('from.index') }}</span>
      <span @click="handleToPage('services', 1)">{{ $t('from.service') }}</span>
      <span @click="handleToPage('productView', 5)">{{ $t('from.product') }}</span>
      <span @click="handleToPage('about', 2)">{{ $t('from.about') }}</span>
      <span @click="handleToPage('testimonial', 3)">{{ $t('from.putai') }}</span>
      <span @click="handleToPage('contact', 4)">{{ $t('from.contact') }}</span>
    </div>
    <advantageView />
    <div class="elementor-section-boxed">
      <h2>{{ $t('from.service') }}</h2>
      <div class="elementor-widget-image-gallery">
        <div class="gallery-item" v-for="(item, index) in srcList" :key="index">
          <div class="gallery-item-box">
            <el-image class="el-image" :src="item.url" :preview-src-list="bigSrcList" fit="scale-down">
            </el-image>
          </div>
          <div class="gallery-item-title">{{ item.title }}</div>
        </div>
      </div>
    </div>
    <productView />
    <caseView @handleToPage="handleToDetail" :language="language" />
    <partnerView />
    <footerView />
  </div>
</template>
<script>
import footerView from '../components/footer.vue'
import partnerView from '../components/partner.vue'
import advantageView from '../components/advantage.vue'
import productView from '../components/product.vue'
import caseView from '../components/case.vue'
export default {
  components: {
    partnerView, footerView, advantageView, productView, caseView
  },
  data() {
    return {
      form: {},
      isShow: false,
      language: 'zh',
      bigSrcList: [
        'https://img.sdaily.cn/WechatIMG187.png',
        'https://img.sdaily.cn/WechatIMG188.png',
        'https://img.sdaily.cn/WechatIMG189.png',
        'https://img.sdaily.cn/WechatIMG190.png',
        'https://img.sdaily.cn/WechatIMG191.png',
        'https://img.sdaily.cn/WechatIMG192.png',
      ],
      srcList: []
    }
  },
  mounted() {
    if (window.sessionStorage.getItem('language') == 'en') {
      this.$i18n.locale = 'en'
      this.onEnList()
    } else {
      this.$i18n.locale = 'zh'
      this.onzhList()
    }
  },
  methods: {
    handleCommand(text) {
      if (text == '英文') {
        this.$i18n.locale = 'en'
        this.language = 'en'
        window.sessionStorage.setItem('language', 'en')
        this.onEnList()
      } else {
        this.$i18n.locale = 'zh'
        this.language = 'zh'
        window.sessionStorage.setItem('language', 'zh')
        this.onzhList()
      }
    },
    onEnList() {
      this.srcList = [
        {
          url: 'https://img.sdaily.cn/WechatIMG187.png', title: 'PROTAC Design'
        },
        {
          url: 'https://img.sdaily.cn/WechatIMG188.png', title: 'Molecule Docking'
        },
        {
          url: 'https://img.sdaily.cn/WechatIMG189.png', title: 'Molecular  Dynamics Simulation'
        },
        {
          url: 'https://img.sdaily.cn/WechatIMG190.png', title: 'DFT Calculation'
        },
        {
          url: 'https://img.sdaily.cn/WechatIMG191.png', title: 'Chemical Synthesis'
        },
        {
          url: 'https://img.sdaily.cn/WechatIMG192.png', title: 'Biological Evaluation'
        },
      ]
    },
    onzhList() {
      this.srcList = [
        {
          url: 'https://img.sdaily.cn/WechatIMG187.png', title: 'PROTAC设计'
        },
        {
          url: 'https://img.sdaily.cn/WechatIMG188.png', title: '分子對接'
        },
        {
          url: 'https://img.sdaily.cn/WechatIMG189.png', title: '分子动力学模拟'
        },
        {
          url: 'https://img.sdaily.cn/WechatIMG190.png', title: 'DFT計算'
        },
        {
          url: 'https://img.sdaily.cn/WechatIMG191.png', title: '化学合成'
        },
        {
          url: 'https://img.sdaily.cn/WechatIMG192.png', title: '生物活性评价'
        },
      ]
    },
    handleToDetail(url) {
      this.$router.push({
        name: 'detail',
        query: {
          url: url
        }
      })
    },
    // 一键回到顶部
    handleGoTop() {
      scrollTo(0, 0);
    },
    handleToPage(url, index) {
      this.$router.push({
        name: url,
        query: { index: index }
      })
      this.isShow = false
    },
    handleShowMenu() {
      this.isShow = true
    },
    handleCloseMenu() {
      this.isShow = false
    }
  }
}
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 750px) {
  .show-builder-menu {
    position: fixed;
    top: 52px;
    left: 0;
    width: 100%;
    z-index: 99;
    background-color: #f7fdfb;
    display: flex;
    flex-direction: column;

    span {
      line-height: 40px;
      padding: 0 20px;
      border-bottom: 1px solid #d5dbd9;
    }
  }

  .screen1 {
    background: url('../assets/images/putai-bg.jpg');
    background-repeat: no-repeat;
    background-size: 100%;



    .screen1-container {
      width: 100%;
      height: 100%;
      background: #fff;
      box-sizing: border-box;
      background-color: rgba(0, 0, 0, 0.5);

      .elementor-button-text {
        display: flex;
        margin: 20px auto 0;
        border-color: #fff;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        background-color: rgba($color: #000000, $alpha: 0);
      }
    }

    .screen1-nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #ffffff99;
      margin-bottom: 20px;

      .screen1-nav-logo {
        padding-left: 15px;

        img {
          width: 64;
          height: 47px;
        }
      }

      .screen1-nav-tabs {
        padding-right: 15px;

        .iconfont {
          margin-left: 10px;
          color: #fff;
        }

        .screen1-nav-menu {
          display: none;

          span {
            font-size: 18px;
            padding: 0 16px;
            color: #ffffff77;
            cursor: pointer;
          }

          span:hover {
            font-weight: bold;
            color: #fff;
          }
        }
      }
    }

    .heading-h1 {
      font-size: 24px;
      text-align: center;
      color: #e1e8ed;
      padding: 4px;
      box-sizing: border-box;

    }
  }
}

@media only screen and (min-width:751px) {
  .screen1 {
    background: url('../assets/images/putai-bg.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100vh;
    height: 100vh;

    .screen1-container {
      width: 100%;
      height: 100%;
      background: #fff;
      padding: 20px 30px 30px 60px;
      box-sizing: border-box;
      background-color: rgba(0, 0, 0, 0.5);

      .elementor-button-text {
        display: flex;
        margin: 80px auto 0;
        border-color: #fff;
        color: #fff;
        font-size: 26px;
        font-weight: bold;
        background-color: rgba($color: #000000, $alpha: 0);
      }
    }

    .screen1-nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #ffffff99;
      margin-bottom: 120px;

      .screen1-nav-logo {
        padding-left: 35px;

        img {
          width: 193px;
          height: 142px;
        }
      }

      .screen1-nav-tabs {
        padding-right: 35px;

        .iconfont {
          display: none;
        }

        .screen1-nav-menu {
          display: flex;
          background-color: none;

          span {
            font-size: 18px;
            padding: 0 16px;
            color: #ffffff77;
            cursor: pointer;
          }

          span:hover {
            font-weight: bold;
            color: #fff;
          }
        }
      }
    }

    .heading-h1 {
      font-size: 70px;
      text-align: center;
      color: #e1e8ed;
      padding: 10px;
      box-sizing: border-box;
    }

  }
}
</style>